
export const redirectPath = 'redirect';
export const destinationProp = 'destination';
export declare type RedirectionQueryParams = { [destinationProp]: string; [key: string]: string };

export declare type RedirectionData = { [key: string]: string };

export enum RedirectionViewState {
    Loading = 'loading',
    Failed = 'failed',
}
